module.exports = __webpack_public_path__ + "img/sld_acdb_panel_disable.ee2fc5c4.svg";